import { TabTypes } from '../Content/IContent'
import type { IItem } from '../Items/IItem'
import { openContent } from '../Content/Content.actions'
import { useTranslation } from 'react-i18next'
import { ReactComponent as AddListing } from '../Icons/add-listing.svg'
import { ReactComponent as Remove } from '../Icons/remove.svg'
import { ReactComponent as Duplicate } from '../Icons/duplicate.svg'
import { ReactComponent as EditIcon } from '../Icons/icons-ic-pen.svg'
import { ReactComponent as MoveUp } from '../Icons/move-up.svg'
import { ReactComponent as MoveDown } from '../Icons/move-down.svg'
import { duplicateItems } from '../Items/Items.action'
import {
  openDeleteItemsModal,
  openEditManyItemsAtOnceModal,
} from '../UI/UI.reducer'
import {
  moveTopItems,
  moveBottomItems,
  moveUpItems,
  moveDownItems,
} from './List.actions'
import { useAppDispatch, useAppSelector } from '../Store/hooks'
import { SellListType } from '../SellView/ISellView'
import { isItemPublished } from './helpers'

export const useGetContextMenu = (type: TabTypes) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const listsById = useAppSelector((state) => state.lists.byId)
  const itemsById = useAppSelector((state) => state.items.byId)
  const clickedItems = useAppSelector((state) => state.ui.clickedItems)
  const getSelectedItemsFromList = (listId: string) => {
    return listsById[listId]?.items.filter((item) => itemsById[item]?.isChecked)
  }

  if (type === TabTypes.List) {
    return [
      {
        name: t('list_contextmenu_newAd'),
        icon: <AddListing />,
        action: (selectedItem: IItem) => {
          dispatch(
            openContent(
              {
                type: TabTypes.Item,
                id: `newitem-${selectedItem.listId}`,
                selected: true,
                name: selectedItem.header,
              },
              selectedItem.header
            )
          )
        },
      },
      {
        name: t('list_contextmenu_delete'),
        icon: <Remove />,
        action: (selectedItem: IItem) => {
          dispatch(openDeleteItemsModal({ id: selectedItem.listId }))
        },
      },
      {
        name: t('list_contextmenu_duplicate'),
        icon: <Duplicate />,
        action: (selectedItem: IItem) => {
          if (!selectedItem.id) return
          dispatch(duplicateItems(selectedItem.listId, [selectedItem.id]))
        },
      },
      (item: IItem) => ({
        name: isItemPublished(item.publishResult)
          ? t('list_contextmenu_handle_published')
          : t('list_contextmenu_edit'),
        icon: <EditIcon />,
        action: (selectedItem: IItem) => {
          if (isItemPublished(item.publishResult)) {
            return dispatch(
              openContent(
                {
                  type: TabTypes.SellView,
                  id: 'sellview',
                  selected: true,
                  name: t('header_sellView'),
                  sellViewType: SellListType.Unsold,
                },
                t('header_sellView')
              )
            )
          }

          const selectedItems = getSelectedItemsFromList(selectedItem.listId)
          selectedItems.length > 1
            ? dispatch(
                openEditManyItemsAtOnceModal({
                  id: selectedItem.listId,
                  items: selectedItems,
                })
              )
            : selectedItems.map((i) =>
                dispatch(
                  openContent(
                    {
                      type: TabTypes.Item,
                      id: selectedItem.id!,
                      name: selectedItem.header,
                      selected: true,
                    },
                    selectedItem.header
                  )
                )
              )
        },
      }),
      {
        name: t('list_contextmenu_moveFirst'),
        icon: <MoveUp />,
        action: (selectedItem: IItem) => {
          const selectedItems = getSelectedItemsFromList(selectedItem.listId)
          dispatch(moveTopItems(selectedItem.listId, selectedItems))
        },
      },
      {
        name: t('list_contextmenu_moveLast'),
        icon: <MoveDown />,
        action: (selectedItem: IItem) => {
          const selectedItems = getSelectedItemsFromList(selectedItem.listId)
          dispatch(moveBottomItems(selectedItem.listId, selectedItems))
        },
      },
      {
        name: t('list_contextmenu_moveUp'),
        icon: <MoveUp />,
        action: (selectedItem: IItem) => {
          dispatch(
            moveUpItems(
              selectedItem.listId,
              clickedItems.map((x) => x.itemId!)
            )
          )
        },
      },
      {
        name: t('list_contextmenu_moveDown'),
        icon: <MoveDown />,
        action: (selectedItem: IItem) => {
          dispatch(
            moveDownItems(
              selectedItem.listId,
              clickedItems.map((x) => x.itemId!)
            )
          )
        },
      },
    ]
  }
  return [
    {
      name: t('list_contextmenu_newAd'),
      icon: <AddListing />,
    },
    {
      name: t('list_contextmenu_delete'),
      icon: <Remove />,
    },
    {
      name: t('list_contextmenu_duplicate'),
      icon: <Duplicate />,
    },
    {
      name: t('list_contextmenu_edit'),
      icon: <EditIcon />,
    },
    {
      name: t('list_contextmenu_moveFirst'),
      icon: <MoveUp />,
    },
    {
      name: t('list_contextmenu_moveLast'),
      icon: <MoveDown />,
    },
    {
      name: t('list_contextmenu_moveUp'),
      icon: <MoveUp />,
    },
    {
      name: t('list_contextmenu_moveDown'),
      icon: <MoveDown />,
    },
  ]
}
